import createClient, { type Middleware } from 'openapi-fetch';
import type { paths, components } from '@/api-types';
import { getAuthToken } from '@/features/auth/store';

// Middleware reads the token from authStore on every request, so first-render
// queries already carry the bearer header (store bootstraps from
// sessionStorage at module load) and later token changes propagate without
// any subscribe / re-init dance.
const authMiddleware: Middleware = {
  onRequest({ request }) {
    const token = getAuthToken();
    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }
    return request;
  },
};

export const apiClient = createClient<paths>({ baseUrl: 'https://api.lona.finance' });
apiClient.use(authMiddleware);

// Type aliases re-exported so consumer imports stay short
export type OrderSchema = components['schemas']['OrderSchema'];
export type OrderCreateSchema = components['schemas']['OrderCreateSchema'];
export type ClientSchema = components['schemas']['ClientSchema'];
export type ClientPatchSchema = components['schemas']['ClientPatchSchema'];
export type ClientInfoSchema = components['schemas']['ClientInfoSchema'];
export type ProductSchema = components['schemas']['ProductSchema'];
export type ProductCreateSchema = components['schemas']['ProductCreateSchema'];
export type ShopSchema = components['schemas']['ShopSchema'];
export type DadataSuggestionOut = components['schemas']['DadataSuggestionOut'];
export type PagedOrderSchema = components['schemas']['PagedOrderSchema'];

export const OrderCreateSchemaSourceEnum = {
  Manual: 'manual',
  Widget: 'widget',
  Onec: '1c',
  Bitrix: 'bitrix',
} as const;
